import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Categoria } from "models/ECF/Categoria";
import { SideInput } from "components/Inputs/SideBar/SideInput";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import RadioGroup from "components/RadioGroup/RadioGroup";
import DropZone from "components/DropZone/Dropzone";
import IconButton from "components/IconButton/IconButton";

const CategoriaEdit = ({ categoria, setCategoria }) => {
  const ESTATUS_LIST = Categoria.ESTATUS_LIST;

  const onFileChange = (files) => {
    setCategoria({ ...categoria, Img: files, _EliminarImagen: (files?.length ?? 0) === 0, ImagenBase64: null });
  };

  return (
    categoria !== undefined && (
      <Col>
        <Form
          action=""
          className="form-horizontal"
          id="TypeValidation"
          method="">

          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            {categoria?.ImagenBase64 ? (
              <InputContainer
                labelClassName={'d-flex'}
                rowStyle={{ width: '100%', display: 'flex', justifyContent: 'center' }}
                style={{ display: 'flex', justifyContent: 'center', width: '100%', textAlign: 'center' }}>
                <div style={{ display: 'flex' }}>
                  <div style={{ width: '100%' }}>
                    <img src={
                      categoria.ImagenBase64?.startsWith("data:image")
                        ? categoria.ImagenBase64
                        : `data:image/png;base64,${categoria.ImagenBase64}`
                    } alt="Imagen seleccionada"
                      style={{ maxWidth: "200px", maxHeight: "200px" }} />
                  </div>

                  <IconButton styles={{ height: '2.5rem' }}  >
                    <i className="fa fa-trash" onClick={() => setCategoria({ ...categoria, ImagenBase64: null, _EliminarImagen: true })}></i>
                  </IconButton>
                </div>

              </InputContainer>
            ) : (
              <InputContainer
                label="Imagen"
                labelClassName={'d-flex'}
                rowStyle={{ display: 'flex', justifyContent: 'center', width: '100%' }}
                style={{ display: 'flex', justifyContent: 'center', width: '100%', textAlign: 'center' }}>
                <DropZone
                  label="Seleccionar Imagen"
                  updateFilesCb={onFileChange}
                  multiple={false}
                  type="image" />
              </InputContainer>
            )}
          </div>

          <SideInput
            label="Nombre"
            name="Nombre"
            type="text"
            value={categoria?.Nombre || ""}
            setState={setCategoria}
            required
          />
          <InputContainer stacked label="Estatus" labelClassName={"d-flex"}>
            <RadioGroup
              name="Estatus"
              options={ESTATUS_LIST}
              selectedOption={categoria?.Estatus || Categoria.DEFAULT_ESTATUS_VALUE}
              onChange={(e) => setCategoria({ ...categoria, Estatus: e.target.value })}
              disabled={!categoria.IdSec}
            />
          </InputContainer>
        </Form>
      </Col>
    )
  );
};
export default CategoriaEdit;
